import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { Settings } from "../common/settings.ts";

export const emptySplitApi = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: Settings.getBackendBaseUrl() + '/',
        prepareHeaders: (headers) => {
            const oidcKey = Object.keys(sessionStorage)
                .filter(key => key.startsWith(Settings.getStorageKeyPrefixOidc()))[0];
            const storageState = JSON.parse(sessionStorage.getItem(oidcKey) || '{}');
            if (storageState?.access_token) {
                headers.set("Authorization", `Bearer ${storageState.access_token}`)
            }
            return headers;
        },
        responseHandler: (response) => {
            return response.json();
        }
    }),
    endpoints: () => ({}),
    keepUnusedDataFor: 0
})
